import { render, staticRenderFns } from "./knowledge-addEdit.vue?vue&type=template&id=7ec65894&"
import script from "./knowledge-addEdit.vue?vue&type=script&lang=js&"
export * from "./knowledge-addEdit.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-addEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports